export enum ReportForms {
  InHouseGuest = 'InHouseGuest',
  Occupancy = 'Occupancy',
  UnbilledTransactions = 'UnbilledTransactions',
  UnbilledEarned = 'UnbilledEarned',
  InvoiceSummary = 'InvoiceSummary',
}
